module.exports = __webpack_public_path__ + "static/7-59c17d77c412e05f63e8571c305b2402.png";